/**
 * @file: CanteenFeedback.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂反馈建议
 */
import request from '@/utils/request'

/**
 * 小程序-新增投诉建议(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function proposalCanteenfeedbackAppletAdd(data) {
  return request({
    type: 'biz',
    url: 'proposal/canteenFeedback/applet/add',
    method: 'post',
    data
  })
}

/**
 * 用户反馈管理列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function proposalCanteenfeedbackList(data) {
  return request({
    type: 'biz',
    url: 'proposal/canteenFeedback/list',
    method: 'post',
    data
  })
}

/**
 * 设置已读(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function proposalCanteenfeedbackUpdate(data) {
  return request({
    type: 'biz',
    url: 'proposal/canteenFeedback/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/CanteenFeedback.js